const useDevices = async () => {
  const devices = await navigator.mediaDevices.enumerateDevices();
  const videos = devices.filter((device) => device.kind === "videoinput");
  const mics = devices.filter((device) => device.kind === "audioinput");
  const audios = devices.filter((device) => device.kind === "audiooutput");
  return {
    videos,
    mics,
    audios,
  };
};

export default useDevices;
